import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import React from 'react';
import { useConsent } from '@/common/Contexts/Consent/ConsentContext';
import { BottomSheet } from "@componentsShared/BottomSheet";
import ModalContent from "@/components/ConsentModal/ModalContent";
export var ConsentModal = function ConsentModal(_ref) {
  var isVisible = _ref.isVisible;
  var _useConsent = useConsent(),
    consentState = _useConsent.consentState,
    actions = _useConsent.actions;
  if (!isVisible || !consentState.consentInfo) {
    return null;
  }
  var screens = [{
    title: '',
    key: 'key1',
    component: /*#__PURE__*/React.createElement(ModalContent, null)
  }];
  var handleAccept = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return actions.action__acceptConsent();
          case 1:
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.error('Failed to accept consent:', _t);
            // Handle error - could show a toast or retry mechanism
          case 3:
            _context.p = 3;
            return _context.f(3);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2, 3, 4]]);
    }));
    return function handleAccept() {
      return _ref2.apply(this, arguments);
    };
  }();
  var consentInfo = consentState.consentInfo;
  return /*#__PURE__*/React.createElement(BottomSheet, {
    open: isVisible,
    setModalOpen: function setModalOpen() {},
    screens: screens,
    onClose: function onClose() {},
    onOpen: function onOpen() {},
    haveClose: false,
    maxHeight: "90%",
    modalDesign: {},
    hideTitleBar: true,
    zeroHeightHead: true
  });
};